import Table from 'react-bootstrap/Table';
import SiteCommandInterface from './OverviewSiteCommandInterface';
import Devices from './OverviewDevices';

// Sites on kohteita, joilla on devicejä (käytännössä piirejä)
// App
// |- Sites
//    |-SiteCommandInterface
//    |-Devices
//      |-CommandInterface
const Sites = ({config, measurements, history, userLevel, main_callback}) => {
    //const Sites = ({config}) => {
      //console.log('sites-sites', config)
      
    
      //return (<><h2>config</h2></>) ;
      
      if (config) {
    
    
    
        //console.log('sites-config', config);
        //console.log('sites-measurements', measurements);
        //console.log('sites-history', history);

    
       // let history = null;
        
        return (
          <>
              <Table bordered>
                <thead>
                  <tr>
                    {/*
                    <th>Site</th>
                    <th>Device</th>
                    */}
                    <th className="col-sm-2">Kohde</th>
                    <th>Piirit</th>
                  </tr>
                </thead>
      
                <tbody>
                  {
                  //config.forEach(site => {
                    config.map((item, index) => {
                      let site = item;
                      let site_name = site['name'];
                      //console.log('looppi', site_name, site)
                      //console.log('looppi-config', config)


                      let hasAtLeastOneMcadex = (site['devices'].find((element) => element['type'] === 'mcadex')) === undefined ? false : true;
                      //console.log('looptest', hasAtLeastOneMcadex)


                      // TODO: historiassa pitäisi laittaa eteenpäin ainoastaan kyseisen siten historia
                      return (
                        <>
                          <tr>
                            <td><b>{site_name}</b></td>
                            
                            { userLevel > 1 &&
                              <SiteCommandInterface key={site.id} mcadexinterface={hasAtLeastOneMcadex} site={site} config={config} measurements={measurements} userLevel={userLevel} main_callback={main_callback}></SiteCommandInterface>
                            }
                     
                              <Devices mcadexinterface={hasAtLeastOneMcadex} site={site} config={config} measurements={measurements} userLevel={userLevel} history={history} main_callback={main_callback}></Devices>
      {/*
                            <Chart name={site_name} config={config} history={history}></Chart>
                      */}             
                      
    
    
                          </tr>
                        </>
                      )
    //                })                
                  })
    }
                </tbody>
      
      
              </Table>
          </>
        )
      
    
    
      }
    
    }
    //          <Sites config={config_sites} measurements={measurements} history={history} main_callback={main_callback}></Sites>
    
    /*
    {site_config && site_config['devices'].map((item, index) => {
    
      return <Device item={item} measurements={measurements} history={history} main_callback={main_callback} />
    })}
    */

    
export default Sites